module.exports = __webpack_public_path__ + "static/media/securecard.2161a875.png";